import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg from '../Svg';

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: "10",
  height: "4",
  rx: "1",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: "10",
  height: "4",
  rx: "1",
  fill: "none"
});

var Minus = function Minus(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#FFFFFF' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Minus icon' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 10 10",
    fill: "none"
  }, rest), _ref2, /*#__PURE__*/React.createElement("rect", {
    width: "10",
    height: "2",
    rx: "1",
    fill: color
  }), _ref3);
};

export default Minus;